import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Latin from "./GloriaHallelujah-Regular-LYjYdHv3kUk9BMV96EIswT9DIbW-MIS71zOmvVCEZ6g.woff2";

export const GloriaHallelujahFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: Latin,
    descriptors: {
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN,
      weight: "400",
    },
  },
];
